import { type FC, useState } from 'react';
import { Checkbox } from '@matrix-forge/ui/components/checkbox';
import { Button } from '@matrix-forge/ui/components/button';
import { TosText } from '@/utils/tos';

// A modal dialog that appears when the user has either never accepted the terms of service
// or has not accepted them since they were last updated.
export const TermsOfService: FC<{ onAccept: () => void }> = ({ onAccept }) => {
  const [isChecked, setIsChecked] = useState(false);
  const toggleChecked = () => setIsChecked((prev: boolean) => !prev);

  return (
    <div className="fixed z-[9999] inset-0 flex items-center justify-center">
      <div className="absolute inset-0 bg-secondary" />
      <div className="relative w-[80vw] shadow-md bg-background border-2 rounded-md px-8 py-4">
        <h3 className="text-xl font-devo-headings font-normal">Devo AI Assist Terms of Service</h3>
        <div className="border-2 p-2 h-[50vh] overflow-y-scroll text-sm mb-4 mt-4">
          <pre className="whitespace-pre-wrap">{TosText}</pre>
        </div>
        <p className="mb-4 text-base">
          By clicking Continue, you agree to and understand the Devo Product Specific Terms above,
          and warrant that you have the ability to bind your organization to those Terms.
        </p>
        <div className="flex items-center gap-2 mb-4 text-base">
          <Checkbox
            id="terms-of-service-checkbox"
            checked={isChecked}
            onCheckedChange={toggleChecked}
          />
          <label htmlFor="terms-of-service-checkbox">
            I have read and agree to the terms of service.
          </label>
        </div>
        <div>
          <Button onClick={onAccept} disabled={!isChecked}>
            Continue
          </Button>
        </div>
      </div>
    </div>
  );
};
